<div class="overflow-x-auto w-full">
  <table class="table">
    <thead>
      <tr>
          <th scope="col" class="sr-only">Conteúdo</th>
        <ng-container *ngTemplateOutlet="header"></ng-container>
      </tr>
    </thead>

    <tbody>
      @if (!isLoading) {
        @for (item of data; track $index) {
          <tr class="hover:bg-lWhite/5">
            <ng-container *ngTemplateOutlet="body; context: { $implicit: item }"></ng-container>
          </tr>
        }
      }

      @if (isLoading) {
        @for (item of skeletons; track $index) {
          <tr class="animate-pulse">
            <td colspan="999"><div class="bg-lWhite/10 h-6 rounded"></div></td>
          </tr>
        }
      }

      @if (data.length === 0 && !isLoading) {
        <tr>
          <td colspan="999">
            <div class="flex flex-col items-center justify-center py-10">
              <img
                alt=""
                class="w-36 mb-2"
                [src]="theme() === 'dark' ? 'assets/icons/no-data-dark.svg' : 'assets/icons/no-data.svg'"
              />
              <p class="text-lSecondary">Nenhum dado disponível</p>
            </div>
          </td>
        </tr>
      }
    </tbody>

  </table>
</div>

<div class="w-full gap-5 pt-5 flex items-center justify-end">
  <p class="text-color">Mostrando {{ ((page - 1) * size + 1)  }} - {{ (page * size) > total ? total : (page * size) }} de {{ total }}</p>
  <div class="flex">
    <l-icon
      class="text-color cursor-pointer text-xs hover:opacity-85 p-2 {{ isFirstPage ? 'opacity-10 pointer-events-none' : '' }}"
      icon="chevron_left"
      (click)="prevPage()"
    />
    <l-icon
      class="text-color cursor-pointer hover:opacity-85 p-2 {{ isLastPage ? 'opacity-10 pointer-events-none' : '' }}"
      icon="chevron_right"
      (click)="nextPage()"
    />
  </div>

</div>
